import { Col } from 'reactstrap'
import CommonTourSocialMedia from '../Common/CommonTourSocialMedia'

const ThirdStyleSocialMedia = () => {
  return (
    <Col sm="4" className="align-self-center mt-0 text-end">
      <CommonTourSocialMedia time="10 Hours ago" className="step7" />
    </Col>
  )
}

export default ThirdStyleSocialMedia